import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import { BodyTextS, HeadingM } from "./Typography";

export const QuestionnaireBanner = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        bgcolor: "primary.main",
        color: "white",
        borderRadius: 1,
        px: 3,
        py: 2,
    }),
);

export const QuestionnaireBannerTextBold = styled(BodyTextS)(({ theme }) =>
    theme.unstable_sx({
        "&&": {
            color: "#ffffff",
            fontWeight: 600,
        },
    }),
);

export const QuestionnaireBannerText = styled(BodyTextS)(({ theme }) =>
    theme.unstable_sx({
        "&&": {
            color: "#ffffff",
        },
    }),
);

export const QuestionnaireBannerIcon = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        color: "#ffffff",
        width: "2.4rem",
        height: "2.4rem",
        flexShrink: 0,
        alignItems: "center",
        justifyContent: "center",
    }),
);

export const PanelPaper = styled(Paper)(({ theme }) =>
    theme.unstable_sx({
        p: { md: 5, xs: 0 },
    }),
);

export const PanelStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        px: { md: 0, xs: 4 },
    }),
);

export const DetailHeading = styled(HeadingM)(({ theme }) =>
    theme.unstable_sx({
        mb: 1,
    }),
);

export const SkeletonPaper = styled(Paper)(({ theme }) =>
    theme.unstable_sx({
        p: 5,
    }),
);

export const SkeletonStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: 4,
    }),
);

export const HeaderSkeleton = styled(Skeleton)(({ theme }) =>
    theme.unstable_sx({
        width: "70%",
        height: 40,
    }),
);

export const ContractNumberRow = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        gap: 2,
    }),
);

export const ContractNumberSkeleton = styled(Skeleton)(({ theme }) =>
    theme.unstable_sx({
        width: "20%",
        height: 20,
    }),
);

export const AmountSkeleton = styled(Skeleton)(({ theme }) =>
    theme.unstable_sx({
        width: "30%",
        height: 30,
    }),
);

export const DetailRowSkeleton = styled(Skeleton)(({ theme }) =>
    theme.unstable_sx({
        height: 45,
    }),
);

export const SavedAmountSkeleton = styled(Skeleton)(({ theme }) =>
    theme.unstable_sx({
        width: 150,
    }),
);
